import CaliperDashboard from 'features/projects/dashboard/components/dashboards/logging/components/CaliperDashboard';
import useProjectDashboardHubConnection from 'features/projects/dashboard/hooks/useProjectDashboardHubConnection';
import LoggingDashboardContainer from 'features/projects/dashboard/components/dashboards/logging/LoggingDashboardContainer';

const CaliperDashboardController = ({
  projectId,
  renderSlots,
  projectDashboardId,
}) => {
  const { curves, setExtremes, registerDataPointsHandler } =
    useProjectDashboardHubConnection(projectId, projectDashboardId);

  return renderSlots(
    <LoggingDashboardContainer
      curves={curves}
      projectId={projectId}
      setExtremes={setExtremes}
      component={CaliperDashboard}
      registerDataPointsHandler={registerDataPointsHandler}
    />,
  );
};

export default CaliperDashboardController;
